import { select, selectAll, on, append, getAttribute, createNodes, getData, addClass, removeClass } from 'modules/dom'
import { pipe, then, fetchData, getProp, parseOptions } from 'modules/utils'
import { updateLazyLoad } from '../image/image'

export default (el) => {
  const STATUS_SELECT_WRAPPER = '.js-status-select'
  const ACCOUNT_WEBINAR_LIST  = '.js-account-webinar-list'
  const LOADING_WRAPPER  = '.js-resend-certificate-loading'
  const STATE_SUCCESS = 'account-webinar-list__success'
  const STATE_DISABLED_BUTTON = 'button--disabled'
  const STATE_LOADING = 'active'

  const selectElm = select(STATUS_SELECT_WRAPPER, el)
  const list = select(ACCOUNT_WEBINAR_LIST)
  const states = parseOptions(getData('state', el))

  const getWebinarListEndPoint = (statusSelected, paged) => {
    return `${window.location.origin}/wp-json/ecl/v1/account-webinar-list?status=${statusSelected}&paged=${paged}`
  }

  const selectWebinarList = () => {
    const statusSelected = selectElm.value
    return getWebinarListEndPoint(statusSelected, 1)
  }

  const updateWebinarList = (response) => {
    if (typeof response === 'string') {
      response = parseOptions(response)
    }

    if (getProp('html', response) === '') {
      list.innerHTML = states.noResult
    } else {
      const nodes = pipe(
        getProp('html'),
        createNodes
      )(response)

      list.innerHTML = ''
      append(list, nodes)
      updateLazyLoad().handlers(true)
      initDom()
    }
  }

  on('change', pipe(
    selectWebinarList,
    fetchData,
    then(updateWebinarList)
  ), selectElm)

  const initDom = () => {
    const resendButtons = selectAll('.js-resend-certificate', el)
    const paginationElm = select('.js-pagination', el)

    const pagination = (e) => {
      const link = e.target
      const page = link.getAttribute('data-page')
      const statusSelected = selectElm.value

      return getWebinarListEndPoint(statusSelected, page)
    }

    const updateResendCertificate = (response, elm) => {
      const node = document.createElement('span')
      addClass(STATE_SUCCESS, node)
      const textNode = document.createTextNode(response)

      node.appendChild(textNode)
      append(elm.parentNode, node)
    }
    if (paginationElm) {
      on('click', pipe(
        pagination,
        fetchData,
        then(updateWebinarList)
      ), paginationElm)
    }

    if (resendButtons.length) {
      resendButtons.map((resendButton) => {
        resendButton.addEventListener('click', () => {
          const loadingButton = select(LOADING_WRAPPER,resendButton.parentNode )
          addClass(STATE_LOADING, loadingButton)
          const attendeeId = getAttribute('data-attendee-id', resendButton)
          const zoomMeetingId = getAttribute('data-zoom-meeting-id', resendButton)
          const params = `id=${attendeeId}` + (zoomMeetingId ? `&zoom-meeting-id="${zoomMeetingId}"` : '')
          const END_POINT_RESEND_CERTICATE = `${window.location.origin}/wp-json/ecl/v1/resend-certificate?${params}`

          fetchData(END_POINT_RESEND_CERTICATE).then((data) => {
            resendButton.disabled = true
            addClass(STATE_DISABLED_BUTTON, resendButton)
            updateResendCertificate(data, resendButton)
            removeClass(STATE_LOADING, loadingButton)
          })
        })
      })
    }
  }

  initDom()
}
